module.exports = ".ui-g-12 {\n  padding: 0; }\n"